export function activeFilters()
{
	const filters = document.querySelectorAll('.filter-item.active');
	const queryFilters = {};

	filters.forEach((filter) => {
		const type = filter.getAttribute('data-type');
		const tag = filter.getAttribute('id');

		if (!(type in queryFilters)) {
			queryFilters[type] = tag;
		} else {
			queryFilters[type] += `,${tag}`;
		}
	})

	const params = new URLSearchParams(queryFilters)
	return `?${params}`;
}

export function updatePosts()
{
	const url = activeFilters();

	let container = document.querySelector('.res-container');
	let paging = document.querySelector('.pagination');
	let body = document.body;
	let cards = document.querySelectorAll('.post-card');

	body.classList.add('loading');

	let data = {
		run_as_ajax: true,
	};

	$.post(url, data, function (res)
	{
		let clean_res = JSON.parse(res);

		body.classList.add('replacing-posts');

		setTimeout(() => {
			if (container != null) {
				container.innerHTML = clean_res.html;

				let wpNodes = container.querySelectorAll('.animate-in');

				wpNodes.forEach((node) => {
					node.classList.add('active');
				})
			}

			if (paging != null) {
				paging.innerHTML = clean_res.pagination;
			}
		}, 50);

		setTimeout( () => {
			body.classList.remove('loading', 'replacing-posts');

			cards.forEach((node) => {
				node.classList.remove('loading-in')
			})
		}, 250);
	});
}

export function setupFilters()
{
	const filters = document.querySelectorAll('.filter-item');

	const toggleState = (e) => {
		const target = e.currentTarget;
		const parent = target.parentNode;
		
		let siblings = parent.parentNode.querySelectorAll('.filter-item');

		siblings.forEach((sibling) => {
			if (sibling !== target) {
				sibling.classList.remove('active');
			}
		});

		!target.classList.contains('active')
			? target.classList.add('active')
			: target.classList.remove('active');

		updatePosts();
	}
	
	filters.forEach((filter) => {
		filter.addEventListener('click', toggleState);
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/filtering.js